export default __webpack_public_path__ + "static/media/testlodge.29f2612d.svg";